import { appApi } from '@web/app/store/api'
import { IUniversitiesResponse, IUniversitiesParams, IUniversity } from '../types'

export const tableUniversityApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    // Query para obtener el listado de universidades
    getUniversities: builder.query<IUniversitiesResponse, IUniversitiesParams | void>({
      query: (params) => ({
        url: '/api/v1/universities',
        method: 'GET',
        params: params || undefined,
      }),
      // Tag para invalidación automática cuando mutemos datos
      providesTags: ['Universities'],
    }),

    // Query para obtener una sola universidad por ID
    getUniversityById: builder.query<IUniversity, string>({
      query: (id) => ({
        url: `/api/v1/universities/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'Universities', id }],
    }),
  }),
  overrideExisting: false,
})

export const { 
  useGetUniversitiesQuery, 
  useGetUniversityByIdQuery 
} = tableUniversityApi;